/**
 * Modal component for document download options
 */

import React from 'react'
import { Modal, Button, Divider } from 'antd'
import { useTranslation } from 'react-i18next'

const DocumentModal = ({
  visible,
  onCancel,
  onDownloadWithRefs,
  onDownloadWithoutRefs
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={t('v3:ai_download_course_word_doc')}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      className="add-course-download-open"
    >
      <div className="ai-course__table-of-content__document-modal">
        {/* two choices, download with references or download without references */}
        <div className="ai-course__table-of-content__document-modal__choices">
          <div className="ai-course__table-of-content__document-modal__choices__item">
            <Button
              type="primary"
              icon="download"
              onClick={onDownloadWithRefs}
            >
              {t('v3:ai_download_ref')}
            </Button>

            <p>{t('v3:ai_download_ref_content')}</p>
          </div>

          <Divider>or</Divider>
          <div className="ai-course__table-of-content__document-modal__choices__item">
            <Button
              type="primary"
              icon="download"
              onClick={onDownloadWithoutRefs}
            >
              {t('v3:ai_download_without_ref')}
            </Button>

            <p>
              <span>{t('v3:ai_download_two_word')}</span>
              <br />
              {t('v3:ai_download_two_word_content_one')}
              <br />
              {t('v3:ai_download_two_word_content_two')}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default DocumentModal
